import React from "react";
import clsx from "clsx";
import styles from "./AppLoader.module.scss";

/**
 * The one loader of the whole site: the red spinner.
 *
 *   <AppLoader />                 — a page: centred in the free space
 *   <AppLoader variant="block" /> — a section, table, panel or modal body
 *   <AppLoader variant="inline" />— next to text, in a field or a button
 *
 * fullPage={false} (older code) means "block".
 */
const SIZES = { page: 44, block: 30, inline: 14 };

const AppLoader = ({ variant, fullPage = true, size, className, label = "Loading" }) => {
  const kind = variant || (fullPage ? "page" : "block");
  const px = size || SIZES[kind] || SIZES.block;
  const Tag = kind === "inline" ? "span" : "div";
  return (
    <Tag className={clsx(styles[kind], className)} role="status" aria-label={label}>
      <span className={styles.spinner} style={{ width: px, height: px, borderWidth: Math.max(2, Math.round(px / 11)) }} />
    </Tag>
  );
};

export default AppLoader;
